import {
  TAdaptor,
  TInit,
  TTrackEvent,
  TSetUser,
  EAdaptors,
  ITrackEventPayload,
  IHydrateAdaptorPayload,
  IHydratedAdaptor,
  TAllMethodKeys,
} from '../types';
import hydrateAdaptor from '../hydrateAdaptor';
import untrackMethods from '../untrackMethods';
interface IAppFlyerTrackEventPayload extends ITrackEventPayload {
  eventType?: 'EVENT';
  eventRevenue?: number;
  eventRevenueCurrency?: string;
}

// if reporting is too chatty, omit the
const UNTRACKED_METHODS: TAllMethodKeys = [
  'trackLauncherAttemptingToAutoReconnectEvent',
  'trackLauncherConnectionClosedEvent',
  'trackLauncherConnectionEstablishedEvent',
];

type TAF = (...params: any[]) => void;
export const appsFlyerAdaptor: TAdaptor = adaptorPayload => {
  const { enabled, webDevKey } = adaptorPayload.config;
  const { getCurrentUserId, getCurrentISODate } = adaptorPayload;

  if (!enabled || !webDevKey) {
    return undefined;
  }
  const AF: TAF = (...params) => (window as any).AF(...params);

  const init: TInit = () => {
    const snippet = `!function(t,e,n,s,a,c,i,o,p){t.AppsFlyerSdkObject=a,t.AF=t.AF||function(){
      (t.AF.q=t.AF.q||[]).push([Date.now()].concat(Array.prototype.slice.call(arguments)))},
      t.AF.id=t.AF.id||i,t.AF.plugins={},o=e.createElement(n),p=e.getElementsByTagName(n)[0],o.async=1,
      o.src="https://websdk.appsflyer.com?"+(c.length>0?"st="+c.split(",").sort().join(",")+"&":"")+(i.length>0?"af_id="+i:""),
      p.parentNode.insertBefore(o,p)}(window,document,"script",0,"AF","pba",{pba: {webAppId: "${webDevKey}"}})`;

    const scriptId = 'appsFlyer';
    let script = document.getElementById(scriptId);
    if (!script) {
      script = document.createElement('script');
      script.id = scriptId;
      script.innerHTML = snippet;
      document.head.appendChild(script);
    }
  };

  const trackEvent: TTrackEvent = (payload: IAppFlyerTrackEventPayload) => {
    const finalPayload: IAppFlyerTrackEventPayload = { ...payload };
    if (!finalPayload?.eventType) {
      finalPayload.eventType = 'EVENT';
    }

    if (!finalPayload.eventValue) {
      finalPayload.eventValue = {};
    }

    finalPayload.eventValue.eventDate = getCurrentISODate();
    finalPayload.eventValue.platform = 'GAMES';

    if (!finalPayload.eventValue?.userId) {
      const userId = getCurrentUserId();
      if (userId) {
        finalPayload.eventValue.userId = userId;
      }
    }

    return AF('pba', 'event', finalPayload);
  };

  const hydrateAdaptorPayload: IHydrateAdaptorPayload = {
    init,
    trackEvent,
  };

  const baseAdaptor = hydrateAdaptor(hydrateAdaptorPayload);

  const setUser: TSetUser = currentUser => {
    baseAdaptor.trackSetUserEvent(currentUser);

    // AppsFlyer specifically requests for the currentUser.id value here to be quoted
    return AF('pba', 'setCustomerUserId', `'${currentUser.id}'`);
  };

  const interimAdaptor: IHydratedAdaptor = {
    ...baseAdaptor,
    setUser,
  };

  // final pass to untrack certain methods
  const finalAdaptor = untrackMethods(interimAdaptor, UNTRACKED_METHODS);

  return finalAdaptor;
};

appsFlyerAdaptor.NAME = EAdaptors.APPS_FLYER;

export default appsFlyerAdaptor;
